export default __webpack_public_path__ + "static/media/GT_logo.svg.69942b55.png";